import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Save, PlusCircle, HardDrive } from "lucide-react";
import { Input } from "@/components/ui/input";
import { GlassCard, GradButton, Field } from "@/components/erp";
import { SelectBox } from "@/components/Inputs";
import api, { errMsg } from "@/lib/api";

const MODLAR = [{ value: "kapali", label: "Kapalı" }, { value: "test", label: "Test (simülasyon — QNB'ye gitmez)" }, { value: "canli", label: "Canlı (QNB bilgileri gerekli)" }];

const KontorDepo = ({ d, onChange }) => {
  const [adet, setAdet] = useState("");
  const [mb, setMb] = useState("");
  const yukle = async () => {
    try { await api.post("/edonusum/kontor", { adet: Number(adet), aciklama: "QNB kontör yüklemesi" }); setAdet(""); toast.success("Kontör eklendi"); onChange(); } catch (e) { toast.error(errMsg(e)); }
  };
  const depo = async (m, ac) => {
    try { await api.post("/edonusum/depo", { mb: Number(m), aciklama: ac }); setMb(""); toast.success("Depo paketi kaydedildi"); onChange(); } catch (e) { toast.error(errMsg(e)); }
  };
  const k = d.kontor;
  return (
    <div className="grid lg:grid-cols-2 gap-4">
      <GlassCard className="p-5 space-y-3" data-testid="ed-kontor-kart">
        <div className="font-medium">Kontör</div>
        <div className="grid grid-cols-3 gap-2 text-sm">{[["Yüklenen", k.yuklenen, "ed-kontor-yuklenen"], ["Kullanılan", k.kullanilan, "ed-kontor-kullanilan"], ["Kalan", k.kalan, "ed-kontor-kalan"]].map(([l, v, t]) => (
          <div key={l} className="rounded-xl bg-white/[0.04] p-3"><div className="text-xs text-muted-foreground">{l}</div><div className={`font-head text-xl ${l === "Kalan" && d.kontor_az ? "text-amber-300" : ""}`} data-testid={t}>{v}</div></div>
        ))}</div>
        <p className="text-[11px] text-muted-foreground">Giden e-Fatura, e-Arşiv, e-İrsaliye ve gelen e-faturaların her biri 1 kontör düşer. Elle kaydedilen belgeler kontör düşmez.</p>
        <div className="flex gap-2"><Input data-testid="ed-kontor-adet" type="number" min="1" placeholder="Yüklenen kontör adedi" className="bg-white/5" value={adet} onChange={(e) => setAdet(e.target.value)} />
          <GradButton onClick={yukle} disabled={!(Number(adet) > 0)} data-testid="ed-kontor-yukle"><PlusCircle className="w-4 h-4" />Ekle</GradButton></div>
      </GlassCard>
      <GlassCard className="p-5 space-y-3" data-testid="ed-depo-kart">
        <div className="font-medium flex items-center gap-2"><HardDrive className="w-4 h-4" />e-Defter / e-Belge deposu</div>
        <div className="text-sm"><span className="font-head text-xl" data-testid="ed-depo-kullanim">{d.depo.kullanilan_mb.toLocaleString("tr-TR")} MB</span> <span className="text-muted-foreground">/ {d.depo.toplam_mb.toLocaleString("tr-TR")} MB</span></div>
        <div className="h-2 rounded-full bg-white/10 overflow-hidden"><div className="h-full grad-bg" style={{ width: `${Math.min(100, d.depo.yuzde)}%` }} /></div>
        {d.depo.toplam_mb === 0 && <div className="text-xs text-amber-300" data-testid="ed-depo-yok">Depo paketi satın alınmadı. QNB'den başlangıç paketi alındığında aşağıdan kaydedin.</div>}
        <div className="flex flex-wrap gap-2">
          {d.depo.toplam_mb === 0 && <button data-testid="ed-depo-baslangic" onClick={() => depo(500, "Başlangıç paketi 500 MB")} className="px-4 py-2 rounded-full text-sm border border-white/10 hover:bg-white/10">Başlangıç paketi 500 MB satın alındı</button>}
          <div className="flex gap-2 flex-1 min-w-[200px]"><Input data-testid="ed-depo-mb" type="number" min="1" placeholder="Ek paket (MB)" className="bg-white/5" value={mb} onChange={(e) => setMb(e.target.value)} />
            <button data-testid="ed-depo-ekle" disabled={!(Number(mb) > 0)} onClick={() => depo(mb, `Ek paket ${mb} MB`)} className="px-4 rounded-full text-sm border border-white/10 hover:bg-white/10 disabled:opacity-40">Ekle</button></div>
        </div>
      </GlassCard>
    </div>
  );
};

export const EDonusumAyar = () => {
  const [f, setF] = useState(null);
  const [d, setD] = useState(null);
  const load = useCallback(async () => {
    const [a, b] = await Promise.all([api.get("/edonusum/ayar"), api.get("/edonusum/durum")]);
    setF({ ...a.data, sifre: "" }); setD(b.data);
  }, []);
  useEffect(() => { load(); }, [load]);
  if (!f || !d) return null;
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));
  const kaydet = async () => {
    try { await api.put("/edonusum/ayar", { ...f, kontor_uyari: Number(f.kontor_uyari) }); toast.success("e-Dönüşüm ayarları kaydedildi"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const inp = (k, ph = "", type = "text") => <Input data-testid={`ed-${k}`} type={type} placeholder={ph} className="bg-white/5" value={f[k] ?? ""} onChange={(e) => set(k, k.endsWith("_seri") ? e.target.value.toUpperCase().slice(0, 3) : e.target.value)} />;
  return (
    <div className="space-y-4" data-testid="edonusum-ayar">
      <GlassCard className="p-6 space-y-4">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div><div className="font-medium">QNB eSolutions bağlantısı</div><div className="text-xs text-muted-foreground">Modül, QNB'den alınan kullanıcı bilgileri girilip kontör yüklenince aktif olur. Durum: <b className={d.aktif ? "text-emerald-300" : "text-amber-300"} data-testid="ed-aktif-durum">{d.aktif ? "Aktif" : "Pasif"}</b></div></div>
          <GradButton onClick={kaydet} data-testid="ed-kaydet"><Save className="w-4 h-4" />Bağlantıyı kaydet</GradButton>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <Field label="Mod"><SelectBox testid="ed-mod" value={f.mod} onChange={(v) => set("mod", v)} options={MODLAR} /></Field>
          <Field label="QNB kullanıcı adı">{inp("kullanici")}</Field>
          <Field label={`QNB şifre${f.sifre_var ? " (kayıtlı — değiştirmek için yazın)" : ""}`}>{inp("sifre", f.sifre_var ? "••••••••" : "", "password")}</Field>
          <Field label="Firma VKN / TCKN">{inp("vkn")}</Field>
          <Field label="e-Fatura seri (3 harf)">{inp("efatura_seri")}</Field>
          <Field label="e-Arşiv seri (3 harf)">{inp("earsiv_seri")}</Field>
          <Field label="e-İrsaliye seri (3 harf)">{inp("eirsaliye_seri")}</Field>
          <Field label="Kontör azaldı uyarısı (adet)">{inp("kontor_uyari", "", "number")}</Field>
        </div>
        {f.mod === "canli" && <p className="text-xs text-amber-300" data-testid="ed-canli-not">Canlı gönderim, QNB teknik dokümanı ve test hesabı geldiğinde bağlanacak. O zamana kadar test modunu kullanın.</p>}
      </GlassCard>
      <KontorDepo d={d} onChange={load} />
    </div>
  );
};
